import { css } from "styled-components";

export const AccessibleOutlineCSS = css`
  &:focus-visible {
    outline: auto; /* Support Firefox & non-webkit browsers */
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: 2px;
    z-index: 1;
  }
`;
